import axiosInstance from "../instance";

// Get All Categories
const fetchCategories = async () => {
    const response = await axiosInstance.get('/category');
    return response.data;
}

// Add a Category
const addCategory = async (newCategory, formData) => {
    console.log('18 - api file');
    console.log(newCategory);
    console.log('20 - api file');
    console.log(formData);
    // Send any "newCategory" OR "formData"
    const response = await axiosInstance.post('/category', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
}

// Update Category
const updateCategory = async (editCategory) => {
    console.log('18 - api file');
    console.log(editCategory);
    const response = await axiosInstance.put('/category', editCategory, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
}

const deleteCategory = async (categoryId, url) => {

    console.log('delet category');
    console.log(categoryId);
    console.log(url);

    const response = await axiosInstance.delete('/category', { params: { categoryId, url } });
}

export { fetchCategories, addCategory, updateCategory, deleteCategory };